import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import FaqsList from "./components/faqsList/faqsList.jsx";
import Promises from "./components/promises/promises.jsx";
import ProductDetails from "./components/productDetails/productDetails.jsx";
import { VariantSelector } from "./components/variantSelector/variantSelector.jsx";
import { ProductInfo } from "./components/productInfo/productInfo.jsx";
import styles from "./pdp.scss";
import SubscribeBtn from "./components/buttons/subscribeButton/subscribeBtn.jsx";
import MarkupPurchaseDashboard from "@tw/shared-ui-components/lib/components/markupPurchaseDashboard/markupPurchaseDashboard"
import WarmPromptBtn from "./components/buttons/subscribeButton/warmPromptBtn.jsx";
import NavBanner from "./components/navBanner/navBanner.jsx";
import BreadCrumbs from "../common/components/breadCrumbs/breadCrumbs.jsx";
import Footer from "./components/footer/footer";
import ShareIcon from "./components/shareIcon/shareIcon.jsx";
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import RecommendedProducts from "@tw/shared-ui-components/lib/components/recommendedProducts/recommendedProducts";
import ProductGallery from "../common/components/productGallery/productGallery.jsx";
import useAddToCart from "@tw/shared-ui-components/lib/hooks/useAddToCart";
import { updateCartDetails } from "@tw/header-footer/lib/redux/reducers";
import { MARKUP_PURCHASE, MARKUP_PRODUCT_ITEMCODE } from "@tw/shared-ui-components/lib/utils/Constants/Constants"
import {
  getFullRoute,
  getPdmApiUrl,
  getProductStatus,
  getLoggedInUserInfo,
  getPageDetails,
  getParams
} from "../common/utils/helper";
import { UserRoles } from "../common/constant.js";
import {
  PAGES,
  trackProductView,
} from "@tw/shared-ui-components/lib/utils/analytics";
import ErrorScreen from "../common/components/errorScreens/errorScreen.jsx";
import SEOHead from "../common/components/seoHead/seoHead.js";
import SopOrderReminderModal from "@tw/shared-ui-components/lib/components/SopOrderReminderModal"
import { setMarkupPurchaseList } from "../plp/common/redux/reducers";
import { fetchMarkupPurchaseState, setMarkupPurchaseState } from "./redux/reducers";
import {
  removeMarkupPurchaseInformation,
  getMarkupPurchaseInfo,
  getMarkupPurchaseQuantity,
  setMarkupMaxQuantityInfo,
  setMarkupPurchaseQuantity
} from "@tw/shared-ui-components/lib/utils/helper"
import _ from "lodash";
// import { setReportChatBotDetails } from "./redux/reducers";
const Pdp = (props) => {
  const { Link, NextHead } = props;
  const params = getParams();
  const dispatch = useDispatch();
  const navigationType = params?.navigationType || "";
  const breakpoint = useSelector((state) => state.breakpoint);
  const pdpState = useSelector((state) => state.pdpState);
  const markupPurchaseActivity = useSelector((state) => state?.markupPurchaseActivityState);
  const productInfo = pdpState?.info;
  const gallery = pdpState?.gallery;
  const seoConfig = pdpState?.seoConfig;
  const [height, setHeight] = useState(0);
  const pageRef = useRef(null);
  const galleryRef = useRef(null);
  const pdpContentRef = useRef(null);
  const infoRef = useRef(null);
  const triggerRef = useRef(null);
  const footerRef = useRef(null);
  const recoProductsRef = useRef(null);
  const activeKanban = useRef(null);

  const [productDetails, setProductDetails] = useState();
  const [faqs, setFaqs] = useState();
  const [announcementData, setAnnouncementData] = useState({});
  const [btnLoading, setBtnLoading] = useState(false)
  const [initialQuantity, setInitialQuantity] = useState(1)
  const [navigationIndex, setNavigationIndex] = useState(null)
  const pageDetails = getPageDetails(productInfo && productInfo.categories?.length && productInfo.categories[navigationIndex], PAGES.pdp);
  const { onAddToCart, renderDrawerAndModal } = useAddToCart({
    updateCartDetails,
    pageDetails,
  });
  useEffect(() => {
    if (!productInfo) return;
    const apiUrl = getPdmApiUrl();
    axios
      .post(
        `/pdp/${productInfo?.itemCode}/product-details-and-faqs`,
        {},
        { baseURL: apiUrl }
      )
      .then((res) => {
        console.log(res.data);
        setProductDetails(res?.data?.productDetails);
        setFaqs(res?.data?.faqs);
        setAnnouncementData(res?.data?.announcement);
      })
      .catch((err) => console.error(err));
    //處理由 Header Navigation 進入 PDP 頁面麵包屑的顯示邏輯
    if (navigationType && navigationType !== "" && productInfo?.categories && productInfo?.categories?.length > 0) {
      productInfo?.categories.map((parent, index) => {
        parent?.length > 0 && parent?.map((item) => {
          if (item.type == navigationType) {
            setNavigationIndex(index)
          }
        })
      })
    } else {
      productInfo?.categories.map((parent, index) => {
        parent?.length > 0 && parent?.map((item) => {
          if (item.type == "product") {
            setNavigationIndex(index)
          } else {
            setNavigationIndex(0)
          }
        })
      })
    }

    activeKanban && activeKanban.current?.onReset()
  }, [productInfo]);


  // recently explored products
  // -----------------------------------

  const [recommendedProductCodes, setRecommendedProductCodes] = useState([]);

  const recentlyBrowsed = (productCodes) => {
    return productCodes?.find((item) => item == productInfo?.itemCode);
  };

  function getStorageValue(key, defaultValue) {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem(key);
      return saved !== null ? JSON.parse(saved) : defaultValue;
    }
  }

  // recently explored products
  // --------------------------------------
  useEffect(() => {
    if (!productInfo) return;
    let recentlyBrowsedLocal = getStorageValue(
      "recentlyBrowsedProductCodes",
      []
    );
    if (recentlyBrowsedLocal) {
      setRecommendedProductCodes(
        recentlyBrowsedLocal
          ?.filter((productCode) => productCode != productInfo?.itemCode)
          ?.reverse()
      );

      if (recentlyBrowsedLocal?.length >= 10) {
        recentlyBrowsedLocal = recentlyBrowsedLocal.slice(
          1,
          recentlyBrowsedLocal.length
        );
      }

      if (!recentlyBrowsed(recentlyBrowsedLocal))
        recentlyBrowsedLocal.push(productInfo?.itemCode);
      else {
        recentlyBrowsedLocal?.map((product, index) => {
          if (
            index < recentlyBrowsedLocal?.length - 1 &&
            product == productInfo?.itemCode
          ) {
            let temp = recentlyBrowsedLocal[index];
            recentlyBrowsedLocal[index] = recentlyBrowsedLocal[index + 1];
            recentlyBrowsedLocal[index + 1] = temp;
          }
        });
      }
      localStorage.setItem(
        "recentlyBrowsedProductCodes",
        JSON.stringify(recentlyBrowsedLocal)
      );
    } else {
      localStorage.setItem(
        "recentlyBrowsedProductCodes",
        JSON.stringify([productInfo?.itemCode])
      );
    }
  }, [productInfo]);

  useEffect(() => setHeight(window.innerHeight), [height]);

  const getProductInfoHeight = () => {
    if (typeof window != "undefined") {
      const pdpContentTop = pdpContentRef.current
        ? pdpContentRef.current.getBoundingClientRect().top
        : 0;
      const bodyTop = document.body.getBoundingClientRect().top;
      const footerHeight = footerRef?.current
        ? footerRef?.current.getBoundingClientRect().height
        : 0;
      console.log({ bodyTop, pdpContentTop });
      // return height - pdpContentTop - 93;
      return height - Math.abs(bodyTop - pdpContentTop) - footerHeight;
    }
  };
  const LoggedInUserRole = getLoggedInUserInfo().role;

  const skuRelateCode = useMemo(
    () => [productInfo?.itemCode],
    [productInfo?.itemCode]
  );

  const getProductStructuredData = (productInfo, gallery) => {
    let structuredData = {
      "@context": "https://schema.org/",
      "@type": "Product",
      name: productInfo?.productName,
      image: gallery[0]?.url,
      description: productInfo?.summary,
      brand: {
        "@type": "Brand",
        name: productInfo?.productBrand,
      },
      sku: productInfo?.itemCode,
      offers: {
        "@type": "Offer",
        url: getFullRoute(),
        priceCurrency: "TWD",
        price: productInfo?.price,
        availability: "",
        itemCondition: "",
      },
    };
    return JSON.stringify(structuredData);
  };

  // tealium tracking
  useEffect(() => {
    // TEAL-2330
    let timer;
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      let times = 0;
      timer = setInterval(async () => {
        if (window?.utag && productInfo) {
          clearInterval(timer)
          await trackProductView({
            product: productInfo,
            page: pageDetails,
          });
        } else {
          if (times >= 20) {
            clearInterval(timer)
          }
          times++
        }
      }, 1000);
    }
    if (productInfo && typeof window !== 'undefined' && typeof window !== undefined) {
      const defaultMarkupPurchase = getMarkupPurchaseQuantity()
      const productQuantity = defaultMarkupPurchase && JSON.stringify(defaultMarkupPurchase) !== "{}" && defaultMarkupPurchase?.itemCode == productInfo?.itemCode ? getMarkupPurchaseQuantity()?.quantity : 1;
      productInfo.quantity = productQuantity;
      sessionStorage.setItem(MARKUP_PRODUCT_ITEMCODE, productInfo?.itemCode)
      setInitialQuantity(productQuantity)
      getMarkupPurchaseState(productInfo)
    }
    return () => {
      clearTimeout(timer);
    };
  }, [productInfo, navigationIndex]);

  const handleQuantityChange = (quantity) => {
    let product = { ...productInfo }
    product.quantity = quantity;
    setInitialQuantity(quantity)
    getMarkupPurchaseState(product)
    setBtnLoading(true)
    setMarkupPurchaseQuantity({ quantity: quantity, itemCode: product?.itemCode })
  }
  const changeFun = useCallback((product) => {
    dispatch(fetchMarkupPurchaseState(product))
      .then((res) => {
        if (res) {
          let times = 0;
          times = setTimeout(() => {
            clearInterval(times)
            setBtnLoading(false)
            dispatch(setMarkupPurchaseState(res));
            res?.itemMaxQuantity && setMarkupMaxQuantityInfo(res?.itemMaxQuantity)
          }, 800)
        }
      })
  }, []);
  //  防抖函数
  const debounceFun = useCallback(
    _.debounce(changeFun, 1000, {
      leading: false,
      trailing: true
    }),
    [changeFun]
  );
  const getMarkupPurchaseState = useCallback(
    (product) => {
      debounceFun(product);
    },
    [debounceFun]
  );
  //  TEP-14691
  // useEffect(() => {
  //   if (productInfo && productDetails && productDetails.length > 0 && (typeof window !== "undefined" || typeof window !== undefined)) {
  //     const reportChatBotDetails = {
  //       productPrice: productInfo?.price ? productInfo?.price : 0,
  //       productCode: productInfo?.itemCode ? productInfo?.itemCode : "",
  //       applicableObject: `${getPlainTextContent(productDetails.find((item) => item?.question == "適用對象")?.answer)}`,
  //       capacity: "容量",
  //       expiryDate: "效期",
  //       satisfactionGuarantee: "滿意保證",
  //       instructionsForUse: `${getPlainTextContent(productDetails.find((item) => item?.question == "使用說明")?.answer)}`,
  //       feature: `${getPlainTextContent(productDetails.find((item) => item?.question == "產品特點")?.answer)}`,
  //       ingredient: `${getPlainTextContent(productDetails.find((item) => item?.question == "產品成份")?.answer)}`,
  //       productSales: productInfo?.price ? productInfo?.price : 0,
  //     }
  //     dispatch(setReportChatBotDetails(reportChatBotDetails))
  //   }
  //   return () => {
  //     dispatch(setReportChatBotDetails(null))
  //   };
  // }, [productInfo, productDetails])
  // useEffect(() => {
  //   return () => {
  //     const deleteMetaFieldsKey = ['productPrice', 'productCode', 'applicableObject', 'capacity', 'expiryDate', 'satisfactionGuarantee', 'instructionsForUse', 'feature', 'ingredient', 'productSales']
  //     if (typeof window !== "undefined" && typeof window !== undefined) {
  //       deleteMetaFieldsKey.map((item) => delete window.adaSettings.metaFields[item])
  //     }
  //   };
  // }, [])
  // const getParseText = (html) => {
  //   const reg = new RegExp('<(.+?)>(.*?)</.+?>', 'g');
  //   let flag = false;
  //   const msg = html.replace(reg, (all, tag, content) => {
  //     if (tag === 'strong') {
  //       return content;
  //     } else {
  //       const res = content.replace(new RegExp('<.+?>', 'g'), '');
  //       flag = true;`
  //       return `<p>${res}</p>`;
  //     }
  //   });
  //   if (flag) {
  //     return msg;
  //   } else {
  //     const res = msg.replace(new RegExp('<.+?>', 'g'), '');
  //     return res;
  //   }
  // };
  // 获取纯文本内容
  // const getPlainTextContent = (html) => {
  //   const reg = new RegExp('<.+?>(.*?)</.+?>', 'g');
  //   const msg = html.replace(reg, (all, content) => {
  //     return getParseText(content);
  //   });
  //   const res = msg.replace(new RegExp('<.+?>', 'g'), '<p>');
  //   return res;
  // };
  //  TEP-15551
  // 删除加价购活动看板同步 redux 数据
  const deleteMarkupPurchase = (data) => {
    dispatch(setMarkupPurchaseList(data));
  }
  const resetMarkupPurchaseActivityCaching = () => {
    if (productInfo &&
      markupPurchaseActivity &&
      markupPurchaseActivity?.activityInfo &&
      markupPurchaseActivity?.activityInfo.length > 0 &&
      markupPurchaseActivity?.itemCodes &&
      markupPurchaseActivity?.itemCodes.length > 0 &&
      markupPurchaseActivity?.itemMaxQuantity) {

      const markupPurchaseInfo = getMarkupPurchaseInfo()
      const markupPurchaseArr = markupPurchaseInfo && markupPurchaseInfo[`${MARKUP_PURCHASE}_${productInfo?.itemCode}`]
      if (markupPurchaseArr && markupPurchaseArr.length > 0 && JSON.stringify(markupPurchaseInfo) !== "{}") {
        removeMarkupPurchaseInformation(markupPurchaseInfo, `${MARKUP_PURCHASE}_${productInfo?.itemCode}`)
      }
      activeKanban.current.onReset()
    }
  }
  if (!pdpState) return null;
  if (!productInfo) return <ErrorScreen Link={Link} />;
  return (
    <div className={styles["wrapper"]} ref={pageRef}>
      <SEOHead NextHead={NextHead} seoConfig={seoConfig} />

      <NextHead>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: getProductStructuredData(productInfo, gallery),
          }}
        ></script>
      </NextHead>
      <NavBanner
        pageRef={pageRef}
        galleryRef={galleryRef}
        infoRef={infoRef}
        triggerRef={triggerRef}
        recoProductsRef={recoProductsRef}
      />
      <div className={styles["breadcrumbs-wrapper"]}>
        <BreadCrumbs
          list={
            productInfo &&
            productInfo.categories?.length &&
            productInfo.categories[navigationIndex]
          }
          lastChildName={productInfo && productInfo.productName}
          Link={Link}
          NextHead={NextHead}
          isStructuredData={true}
        />
      </div>
      <div
        className={styles["pdp_content"]}
        style={{
          height: breakpoint === "lg" ? getProductInfoHeight() : undefined,
        }}
        ref={pdpContentRef}
      >
        <div className={styles["product_gallery"]} ref={galleryRef}>
          <ProductGallery
            productCode={productInfo && productInfo.productCode}
            itemCode={productInfo && productInfo.itemCode}
            gallery={gallery}
            labels={productInfo && productInfo.labels}
            isCollected={productInfo && productInfo.isCollected}
            disableAddToCollection={productInfo?.disableAddToCollection}
          />
        </div>

        <div
          className={styles["product_info"]}
          ref={infoRef}
        // style={{
        //   height: breakpoint === "lg" ? getProductInfoHeight() : undefined,
        // }}
        >
          <ProductInfo
            productInfo={productInfo}
            productStatus={getProductStatus(productInfo)}
            productAnnouncement={announcementData}
          />
          <VariantSelector productInfo={productInfo} />

          <div className={styles["subs_and_discount_banners"]}>
            <div className={styles["shareIconDiv"]}>
              {LoggedInUserRole === UserRoles.ABO &&
                !productInfo?.disableAddToCollection ? (
                <ShareIcon itemCode={productInfo && productInfo.itemCode} product={productInfo} />
              ) : null}
            </div>
            <div className={styles["subscribeBtnDiv"]}>
              {productInfo && productInfo.sopValue ? (
                <SubscribeBtn sopProduct={productInfo.sopValue} />
              ) : null}
            </div>

            <div className={styles["subscribeBtnDiv"]}>
              {productInfo && productInfo.pdpTipWord ? (
                <WarmPromptBtn pdpTip={{ pdpTipUrl: productInfo.pdpTipUrl, pdpTipWord: productInfo.pdpTipWord }} />
              ) : null}
            </div>
            {
              productInfo &&
              markupPurchaseActivity &&
              markupPurchaseActivity?.activityInfo &&
              markupPurchaseActivity?.activityInfo.length > 0 &&
              markupPurchaseActivity?.itemCodes &&
              markupPurchaseActivity?.itemCodes.length > 0 &&
              markupPurchaseActivity?.itemMaxQuantity &&
              <div
                style={{
                  margin: breakpoint === "lg" ? '' : '0 16px',
                }}
              >
                <MarkupPurchaseDashboard
                  pageType="PDP"
                  moduleId={MARKUP_PURCHASE}
                  itemCode={productInfo?.itemCode}
                  onChangeCallback={data => {
                    console.log(data, '==========MarkupPurchaseDashboard===========');
                  }}
                  itemCodes={markupPurchaseActivity?.itemCodes}
                  itemMaxQuantity={markupPurchaseActivity?.itemMaxQuantity}
                  activityDetails={markupPurchaseActivity?.activityInfo[0]?.promotionResponse?.promotionResultInfo}
                  onDeleteCallback={deleteMarkupPurchase}
                  ref={activeKanban}
                  btnLoading={btnLoading}
                  markupAdminPurchaseQuantity={initialQuantity}
                />
              </div>
            }
            {/* <DiscountButton /> */}
          </div>

          <div className={styles["faqsDetails"]}>
            {productDetails && <ProductDetails data={productDetails} />}
            {faqs && (
              <FaqsList
                data={faqs}
                title="常見問題"
                NextHead={NextHead}
                isStructuredData={true}
              />
            )}
          </div>
          <Promises ref={triggerRef} />
        </div>
      </div>
      <Footer
        productInfo={productInfo}
        onSuccess={resetMarkupPurchaseActivityCaching}
        productStatusObj={getProductStatus(productInfo)}
        handleQuantityChange={handleQuantityChange}
        btnLoading={btnLoading}
        initialQuantity={initialQuantity}
        ref={footerRef}
      />
      <div className={styles["reco_products"]} ref={recoProductsRef}>
        {/* <div className={styles["recommended_product"]}> */}
        <RecommendedProducts
          sceneType={"SKU_RELATE"}
          relateCode={skuRelateCode}
          heading="您可能也喜歡"
          backgroundColor={"#FAFAFA"}
          onAddToCart={onAddToCart}
        />
        {/* </div> */}

        {recommendedProductCodes?.length ? (
          <div className={styles["recently_browsed_wrapper"]}>
            <RecommendedProducts
              heading={"最近瀏覽過的商品"}
              backgroundColor={"#FAFAFA"}
              onAddToCart={onAddToCart}
              itemCodes={recommendedProductCodes}
            />
          </div>
        ) : null}
      </div>
      {renderDrawerAndModal()}
      <SopOrderReminderModal />
    </div>
  );
};

export default Pdp;
